package com.example.hukakmp.auth

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.js
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider as JsGoogleAuthProvider
import dev.gitlive.firebase.auth.externals.signInWithPopup
import kotlinx.coroutines.await

actual val googleSignInAvailable: Boolean = true

actual class GoogleAuthProvider {
    actual suspend fun signIn(): GoogleSignInResult = try {
        val provider = JsGoogleAuthProvider().apply {
            addScope("email")
            addScope("profile")
        }

        val result = signInWithPopup(Firebase.auth.js, provider).await()
        val credential = JsGoogleAuthProvider.credentialFromResult(result)
        val idToken = credential?.idToken

        if (idToken.isNullOrBlank()) {
            GoogleSignInResult(
                errorMessage = "Google inició sesión, pero no devolvió un token válido."
            )
        } else {
            GoogleSignInResult(idToken = idToken)
        }
    } catch (e: Throwable) {
        GoogleSignInResult(
            errorMessage = e.message ?: "No se pudo iniciar sesión con Google."
        )
    }
}
